export default "__VITE_ASSET__f4613efe__"